export default __webpack_public_path__ + "static/media/image1.1c58f9e1.png";